import React from 'react';
import { Gift } from 'lucide-react';
import { scrollToCompra } from '../utils/scroll';
interface Bonus {
  num: string;
  title: string;
  desc: string;
  extra: string;
  value: string;
}
export function Bonuses() {
  const bonuses: Bonus[] = [{
    num: '01',
    title: 'Guía de Gamificación: 5 Dinámicas de Grupo',
    desc: '5 dinámicas listas para aplicar en el aula que convierten cualquier contenido financiero en una experiencia de aprendizaje activo. Diseñadas para grupos de todos los tamaños, incluyendo los más silenciosos.',
    extra: 'Sin preparación extra. Abres la guía, lees las instrucciones y arrancas.',
    value: 'USD 15'
  }, {
    num: '02',
    title: 'Plantilla de Planificación Anual',
    desc: 'La secuencia completa del año organizada semana a semana. Solo tienes que copiar y pegar en tu planificación oficial.',
    extra: 'Una tarde para tener el año resuelto.',
    value: 'USD 12'
  }, {
    num: '03',
    title: 'Banco de Evaluaciones y Rúbricas',
    desc: 'Evaluaciones listas con tres niveles de dificultad y rúbricas alineadas a competencias. Nunca más construir un examen desde cero bajo presión.',
    extra: 'Materiales ya validados en aulas reales: ahorra horas en cada trimestre.',
    value: 'USD 10'
  }, {
    num: '04',
    title: 'Manual de Respuestas para Preguntas Difíciles',
    desc: '¿Qué respondo cuando preguntan por Bitcoin, por trading o por la devaluación? El manual que te da la respuesta correcta antes de que el alumno te ponga en aprietos.',
    extra: 'Nunca más un silencio incómodo frente a una pregunta financiera inesperada.',
    value: 'USD 9'
  }];
  return <section className="py-6 md:py-8 px-4 bg-brand-dark border-b border-brand-accent/10" data-id="element-42">
      <div className="max-w-5xl mx-auto" data-id="element-43">
        <div className="text-center mb-5" data-id="element-44">
          <div className="inline-flex items-center justify-center bg-brand-accent text-brand-dark font-black px-4 py-1.5 rounded-full mb-3 text-xs shadow-[0_0_20px_rgba(34,197,94,0.5)] tracking-wider uppercase" data-id="element-45">
            <Gift className="w-4 h-4 mr-2" data-id="element-46" />
            Incluidos sin costo extra
          </div>
          <h2 className="text-xl md:text-3xl font-black text-white uppercase tracking-tight" data-id="element-47">
            🎁 Los 4 Bonos Estratégicos
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6" data-id="element-48">
          {bonuses.map((bonus, i) => <div key={i} onClick={scrollToCompra} className="bg-brand-card rounded-lg p-4 md:p-5 border border-brand-accent/30 hover:border-brand-accent transition-colors shadow-[0_4px_15px_rgba(0,0,0,0.5)] relative overflow-hidden flex flex-col cursor-pointer hover:shadow-[0_4px_25px_rgba(34,197,94,0.25)]" data-id="element-49">
              <div className="absolute top-0 right-0 bg-brand-accent text-brand-dark font-black text-[10px] px-2 py-1 rounded-bl-lg" data-id="element-50">
                BONO {bonus.num}
              </div>
              <h3 className="text-sm md:text-base font-black leading-tight text-white mb-2 mt-2 uppercase pr-20" data-id="element-51">
                🎁 {bonus.title}
              </h3>
              <div className="flex items-center gap-2 mb-3" data-id="element-52">
                <span className="text-gray-500 line-through font-black text-xs" data-id="element-53">
                  Valor real: {bonus.value}
                </span>
                <span className="text-brand-accent font-black text-sm neon-glow" data-id="element-54">
                  → GRATIS
                </span>
              </div>
              <p className="text-[11px] md:text-sm text-gray-300 leading-relaxed font-bold mb-3" data-id="element-55">
                {bonus.desc}
              </p>
              <p className="text-[11px] md:text-xs text-brand-accent leading-relaxed font-bold italic mt-auto pt-2 border-t border-white/10" data-id="element-56">
                {bonus.extra}
              </p>
            </div>)}
        </div>

        <div onClick={scrollToCompra} className="bg-brand-card rounded-lg p-5 text-center border-2 border-brand-accent max-w-2xl mx-auto shadow-[0_0_25px_rgba(34,197,94,0.25)] cursor-pointer hover:shadow-[0_0_35px_rgba(34,197,94,0.4)] transition-shadow" data-id="element-57">
          <div className="grid grid-cols-2 gap-3 items-center" data-id="element-58">
            <div className="text-right border-r border-white/10 pr-3" data-id="element-59">
              <p className="text-xs md:text-sm font-black text-gray-300 uppercase" data-id="element-60">
                Valor total de los 4 Bonos
              </p>
              <p className="text-base md:text-lg font-black text-gray-500 line-through" data-id="element-61">
                USD 46.00
              </p>
            </div>
            <div className="text-left pl-3" data-id="element-62">
              <p className="text-xs md:text-sm font-black text-gray-300 uppercase" data-id="element-63">
                Tu precio hoy
              </p>
              <p className="text-lg md:text-2xl font-black text-brand-accent neon-glow uppercase" data-id="element-64">
                🎁 GRATIS
              </p>
            </div>
          </div>
          <p className="text-[10px] md:text-xs text-gray-400 font-bold uppercase tracking-wide mt-3 pt-3 border-t border-white/10" data-id="element-65">
            Solo en este lanzamiento. Incluidos siempre.
          </p>
        </div>
      </div>
    </section>;
}